/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import './Switcher.css';

const Switcher = ({ name, checked, onChange, disabled, ...props }) => {
  return (
    <React.Fragment>
      <input
        id={name}
        name={name}
        disabled={disabled}
        type="checkbox"
        onChange={onChange}
        className="Switcher__checkbox"
        checked={checked}
        {...props}
      />
      <label
        htmlFor={name}
        className={classnames('Switcher__label', {
          'Switcher--is-on': checked,
          'Switcher--is-off': !checked,
          'Switcher--is-disabled': disabled,
        })}
      >
        <span className="Switcher__button" />
      </label>
    </React.Fragment>
  );
};

Switcher.propTypes = {
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

Switcher.defaultProps = {
  disabled: false,
};

export default Switcher;



// WEBPACK FOOTER //
// ../ui-components/components/Switcher/Switcher.jsx